import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: '[window-type-6]',
    templateUrl: './window-type-6.component.html',
    styleUrl: './window-type-6.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WindowType6Component {
  public height = input<number>();

  public leftWindowPositions = computed(() =>
    this.generateWindows({ height: this.height(), rowHeight: 45, xOffset: 26, isLeft: true })
  );

  public rightWindowPositions = computed(() =>
    this.generateWindows({ height: this.height(), rowHeight: 45, xOffset: 97, startingY: 142, isLeft: false })
  );

  private generateWindows(config: {
    height: number;
    rowHeight: number;
    xOffset: number;
    startingY?: number;
    isLeft: boolean;
  }): { x: number; y: number; a?: number; b?: number; c?: number; d?: number; e?: number; f?: number; g?: number; h?: number }[] {
    const { height, rowHeight, xOffset, startingY = 130, isLeft } = config;
    const rows = Math.floor(height / 65);

    return Array.from({ length: rows }, (_, index) => {
      const y = index * rowHeight + startingY;
      return isLeft
        ? { x: xOffset, y }
        : {
            x: xOffset,
            y,
            a: xOffset + 63,
            b: y - 17,
            c: xOffset + 96,
            d: y - 37,
            e: xOffset + 63,
            f: y + 5,
            g: xOffset + 96,
            h: y - 12,
          };
    });
  }

  public trackByIndex = (index: number) => index;
}
